import React, { useState, useEffect, useRef } from 'react';
import {
    Table,
    Button,
    Space,
    Modal,
    message,
    Input,
    Switch,
    Form,
    Select,
} from 'antd';
import useWebPost from '../../utils/useWebPost';
import { checkp, exportToCSV, formatNumber } from '../../utils/functions';
import FullHeightLayout from '../../components/FullHeightLayout';
import ImgUploader from '../../components/ImgUploader';
import CustModal from '../../components/ShowModal';
import renderFileList from '../../components/renderFileList';

const { Option } = Select;
function Yhzhgl() {
    const webPost = useWebPost(); // 直接使用你的钩子
    const [data, setData] = useState([]);
    const [lsdata, setlsData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [lsconfig, setLsconfig] = useState({});
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);
    const [currentEmployee, setCurrentEmployee] = useState(null);
    const [form] = Form.useForm();
    const [zhmodal, setZhmodl] = useState('');
    const [tableScrollY, setTableScrollY] = useState(
        window.innerHeight * 0.7 - 70
    );

    useEffect(() => {
        fetchList(1, pageSize);
        const handleResize = () => {
            setTableScrollY(window.innerHeight * 0.7 - 70);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchList = async (page = 1, pageSize = 10) => {
        setLoading(true);
        try {
            const response = await webPost('yhzhList', {});
            if (response) {
                setData(response);
            }
        } catch (error) {
            console.error('获取银行账户失败:', error);
            message.error('请求失败，请稍后重试');
        } finally {
            setLoading(false);
        }
    };

    const openModal = (employee = { id: 0, zh: '' }) => {
        form.resetFields();
        setCurrentEmployee(employee);

        form.setFieldsValue({
            ...employee
        });
        setModalVisible(true);
    };
    const [bankId, setBankId] = useState(0);
    const [pageId, setPageId] = useState(0);
    const viewls = (rs) => {
        const v = { bank_id: rs.id, page_id: 0, hasMore: true, key: '' };
        setLsconfig(v);
        loadMoreData(v);
    }
    const loadingRef = useRef();
    const loadMoreData = async (v) => {
        const cfg = v || lsconfig;
        console.log('logmoredata', cfg);
        if (loadingRef.current || cfg?.bank_id < 1 || !cfg.hasMore) return;
        loadingRef.current = true;
        try {
            const res = await webPost('getyhls', cfg);

            if (res) {
                if (res.length > 0) {
                    const ds = res.map((item) => {
                        return { ...item, record_type: Number(item.record_type) === 1 ? '收入' : '支出', km: `${item.km}-${item.kmmc}` }
                    })
                    if (lsdata === null) {
                        setlsData(res);
                    } else {
                        setlsData(prev => [...prev, ...res]);
                    }
                    setPageId(res[res.length - 1].id);
                    setLsconfig((prev) => ({ ...prev, page_id: res[res.length - 1].id, hasMore: res.length > 29 }))
                } else {
                    setLsconfig((prev) => ({ ...prev, hasMore: false }))
                }
            }
        } catch (error) {
            console.error('加载失败:', error);
        } finally {
            loadingRef.current = false;
        }
    };
    const updateDeleted = async (rs, v) => {
        const response = await webPost('yhzhSwitch', { id: rs.id, v });
        if (response === 0) {
            message.error('修改失败');
            fetchList(currentPage, pageSize);
            return;
        }
        const newDs = data.map(it => {
            return it.id === rs.id ? { ...it, is_deleted: v } : it;
        });
        setData(newDs);
    }


    // 动态计算表格最大高度（确保分页和表头不滚动）
    const tableHeight = window.innerHeight - 240; // 可根据 header/footer 调整

    const columns = [
        { title: '序号', dataIndex: 'idx', key: 'idx', width: 60, align: 'center', render: (_, __, idx) => ((currentPage - 1) * pageSize + idx + 1) },
        { title: '使用单位', dataIndex: 'dw', width: 180 },
        { title: '帐户名称', dataIndex: 'mc', width: 180 },
        { title: '账号', dataIndex: 'zh', width: 180 },
        { title: '开户行', dataIndex: 'khh', width: 180 },
        { title: '用途', dataIndex: 'yt', width: 180 },
        { title: '说明', dataIndex: 'sm', width: 180 },
        { title: '备注', dataIndex: 'ps', width: 180 },
        {
            title: '余额',
            dataIndex: 'amount',
            key: 'amount',
            width: 160,
            align: 'right',
            render: (_) => (formatNumber(_)),
        },
        { title: '流水1', dataIndex: 'fs1', width: 100, render: (t) => renderFileList(t) },
        { title: '流水2', dataIndex: 'fs2', width: 100, render: (t) => renderFileList(t) },
        { title: '流水备注', dataIndex: 'ps2', width: 100, },
        {
            title: '启用',
            dataIndex: 'is_deleted',
            key: 'is_deleted',
            width: 100,
            render: (value, record) => (
                <Switch
                    checked={value === 0}
                    onChange={(checked) => {
                        const targetValue = checked ? 0 : 1;
                        updateDeleted(record, targetValue);
                    }}
                    checkedChildren="启用"
                    unCheckedChildren="禁用"
                // checkedColor="#52c41a"
                // unCheckedColor="#d9d9d9"
                />
            ),
        },
        {
            title: '操作',
            key: 'action',
            width: 140,
            align: 'center',
            fixed: 'right',
            render: (_, record) => (
                <Space size="middle">
                    <Button size="small" type="link" onClick={() => openModal(record)}>
                        编辑
                    </Button>
                    <Button size="small" type="link" onClick={() => viewls(record)}>
                        查看流水
                    </Button>
                </Space>
            ),
        },
    ];
    const columns2 = [
        { title: '序号', dataIndex: 'idx', key: 'idx', width: 60, align: 'center', render: (_, __, idx) => (idx + 1) },
        { title: '时间', dataIndex: 'date_time', width: 180 },
        { title: '类型', dataIndex: 'record_type', width: 60, render: (_) => (Number(_) === 1 ? '收入' : '支出') },
        { title: '金额', dataIndex: 'amount', width: 140 },
        { title: '项目名称', dataIndex: 'xmmc', width: 140 },
        { title: '费用科目', dataIndex: 'km', width: 140, render: (_, dr) => (<div>{dr?.km + ' ' + dr?.kmmc}</div>) },
        { title: '操作人', dataIndex: 'auditor', width: 100 },
        { title: '备注', dataIndex: 'remark', width: 180 },

    ];

    const saveSbumit = async () => {
        const values = await form.validateFields();
        try {
            const response = await webPost('yhzhSave', {
                id: currentEmployee.id,
                ...values
            });
            if (response) {
                message.success(`${currentEmployee.id > 0 ? '更新' : '添加'}成功`);
                setModalVisible(false);
                fetchList();
            }
        } catch {
            message.error(`${currentEmployee.id > 0 ? '更新' : '添加'}失败`);
        }
    }
    const saveSbumit2 = async () => {
        const values = await form.validateFields();
        try {
            const response = await webPost('yhzhnbzz', values);
            if (response) {
                message.success(`保存成功`);
                setZhmodl(false);
                fetchList();
            }
        } catch {
            message.error(`保存失败`);
        }
    }
    return (
        <FullHeightLayout headerContent={
            <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button type="primary" onClick={() => openModal()}>
                    新建资金账户
                </Button>
                {checkp('cwzhm') && (
                <Button onClick={() => setZhmodl(true)}>
                    内部转账
                </Button>
                )}
            </div>
        }>

            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                loading={loading}
                pagination={{
                    current: currentPage,
                    pageSize,
                    total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        fetchList(page, size);
                    },
                }}
                scroll={{ x: 'max-content', y: Math.max(tableHeight, 200) }} // 至少 200px 

                style={{ marginTop: '8px' }}
            />
            <CustModal open={lsdata !== null}
                onCancel={() => { setlsData(null); setLsconfig({ hasMore: false }) }}
                onOk={() => { setlsData(null); setLsconfig({ hasMore: false }) }}
            >
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ flex: 1, display: 'flex' }}><Input placeholder='项目名称、科目、操作人' style={{ maxWidth: '420px' }}
                        onChange={(e) => setLsconfig((prev) => ({ ...prev, page_id: 0, hasMore: true, key: e.target.value }))}
                        value={lsconfig.key} /><Button type="primary" onClick={() => { setlsData([]); loadMoreData(lsconfig) }}>搜索</Button></div>
                    <Button onClick={() => exportToCSV(lsdata, columns2.splice(1), "账户流水记录")}>下载当前内容</Button>
                </div>
                <div style={{ height: 'calc(70vh - 70px)', overflow: 'auto', paddingTop: '8px' }}>
                    <Table
                        rowKey="id"
                        columns={columns2}
                        dataSource={lsdata}
                        pagination={false}
                        style={{ width: '100%' }}
                        // 1. 开启虚拟滚动
                        virtual={true}
                        // 2. 设置每一行的预估高度 (根据你表格行的实际高度调整，比如 54 或 60)
                        scroll={{ y: tableScrollY }}
                        // 3. 监听滚动事件来实现加载
                        onScroll={(e) => {
                            const { scrollTop, scrollHeight, clientHeight } = e.target;
                            // 离底部 100px 时加载
                            if (scrollTop + clientHeight >= scrollHeight - 100) {
                                loadMoreData(1);
                            }
                        }}
                    />
                </div>
            </CustModal>
            <CustModal
                title={currentEmployee?.id > 0 ? '编辑银行账号' : '添加银行账号'}
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                onOk={saveSbumit}
                width={520}
            >
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item label="使用单位" name="dw"><Input /></Form.Item>
                    <Form.Item label="帐户名称" name="mc"><Input /></Form.Item>
                    <Form.Item label="账号" name="zh"><Input /></Form.Item>
                    <Form.Item label="开户行" name="khh"><Input /></Form.Item>
                    <Form.Item label="用途" name="yt"><Input /></Form.Item>
                    <Form.Item label="说明" name="sm"><Input /></Form.Item>
                    <Form.Item label="余额" name="amount"><Input /></Form.Item>
                    <Form.Item label="备注" name="ps"><Input.TextArea /></Form.Item>
                    <Form.Item label="流水1" name="fs1"><ImgUploader /></Form.Item>
                    <Form.Item label="流水2" name="fs2"><ImgUploader /></Form.Item>
                    <Form.Item label="流水备注" name="ps2"><Input.TextArea /></Form.Item>

                </Form>
            </CustModal>
            <CustModal
                title={'内部转账'}
                open={zhmodal}
                onCancel={() => setZhmodl(false)}
                onOk={saveSbumit2}
                width={520}
            >
                <Form form={form}
                    layout="vertical"
                >
                    <Form.Item label="支出账户" name="zczh">
                        <Select placeholder="请选择支出账户" style={{ width: '100%' }}>
                            {data.map(item => (
                                <Option key={item.zh} value={item.id} >
                                    {item.mc}（{item.zh}）
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="转入账户" name="zrzh">
                        <Select placeholder="请选择转入账户" style={{ width: '100%' }}>
                            {data.map(item => (
                                <Option key={item.zh} value={item.id} >
                                    {item.mc}（{item.zh}）
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item label="金额" name="amount"><Input /></Form.Item>
                    <Form.Item label="备注" name="ps"><Input.TextArea /></Form.Item>
                </Form>
            </CustModal>
        </FullHeightLayout>
    );
}

export default Yhzhgl;